import { render, staticRenderFns } from "./wechat-service-dialog.vue?vue&type=template&id=2f5dbadb&scoped=true"
import script from "./wechat-service-dialog.vue?vue&type=script&lang=js"
export * from "./wechat-service-dialog.vue?vue&type=script&lang=js"
import style0 from "./wechat-service-dialog.vue?vue&type=style&index=0&id=2f5dbadb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dbadb",
  null
  
)

export default component.exports